import { isMarketDynamics } from './modules';
import { agentProductionTerms, marketDynamicsTerms, marketDynamicsTimePeriods, TimePeriods } from '../../constants';
import { terms } from '../../agent-production/constants/agentMovement';

const excludedTimePeriods = [
    agentProductionTerms.last24Months,
    agentProductionTerms.yearToDate,
    agentProductionTerms.annually,
    terms.last60Days,
    terms.last90Days,
    terms.last180Days,
    terms.last365Days,
];

export const isCustomDate = value => value === TimePeriods['Custom Date'];

export const getTimePeriods = module => isMarketDynamics(module) ? marketDynamicsTimePeriods : TimePeriods;

export const getTimePeriodsByModule = ({ module, mlsMembershipList, selectedMlsId }) => {
    const timePeriods = getTimePeriods(module);
    const isMarketDynamicsModule = isMarketDynamics(module);
    return Object.keys(timePeriods).filter(timePeriodKey => !excludedTimePeriods.includes(timePeriodKey)).map((timePeriod) => {
        let option = {
            value: timePeriods[timePeriod],
            label: timePeriod
        };

        if (isMarketDynamicsModule && mlsMembershipList &&
            timePeriods[timePeriod] === marketDynamicsTimePeriods[marketDynamicsTerms.years3Quarterly]) {
            const isMlsSupport3YearsOption = mlsMembershipList.length && mlsMembershipList?.find(mls => mls.mlsId === selectedMlsId)?.supports13Quarters;
            return { ...option, isDisabled: !isMlsSupport3YearsOption };
        }
        return option;
    });
};

export const getTimePeriodLabelKey = (value) => {
    return Object.keys(TimePeriods).find(
        key => TimePeriods[key] === value
    );
};
